export default __webpack_public_path__ + "static/media/bronze_star.95e97c01.png";